import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { BuyButton } from "./BuyButton";
import { OnAirSign } from "./OnAirSign";
import { money } from "../lib/api";
import { useMe } from "../lib/me";

export const Paywall = ({ detail }) => {
  const { me } = useMe();
  const show = detail?.show;
  return (
    <div className="spotlight min-h-[70vh] flex items-center justify-center px-6" data-testid="paywall">
      <div className="panel max-w-md w-full p-8 text-center rise">
        <Lock className="mx-auto h-8 w-8 text-yellow-400" />
        {show ? (
          <>
            <div className="mt-4 flex justify-center"><OnAirSign on size="sm" /></div>
            <h2 className="mt-4 text-2xl font-bold">{show.title}</h2>
            <p className="mt-2 text-sm text-zinc-400">This live show needs a ticket. Hosted by {show.host_name}.</p>
            <BuyButton kind="ticket" itemId={show.id} price={show.price} className="mt-6 w-full" testId="paywall-buy-ticket" />
          </>
        ) : (
          <>
            <h2 className="mt-4 text-2xl font-bold">Members only</h2>
            <p className="mt-2 text-sm text-zinc-400">Rooms are open to camp members. Join for {money(me.membership_price)}/month.</p>
            <BuyButton kind="membership" price={me.membership_price} label={`Join · ${money(me.membership_price)}/mo`} className="mt-6 w-full" testId="paywall-buy-membership" />
          </>
        )}
        <Link to="/" className="mt-4 inline-block text-sm text-zinc-400 hover:text-yellow-300" data-testid="paywall-back-link">Back to the lobby</Link>
      </div>
    </div>
  );
};
